export const AI_MUSIC_GENERATOR_MAX_LYRICS_LENGTH = 3000

export const AI_MUSIC_GENERATOR_MAX_PROMPT_LENGTH = 300
